module.exports = __webpack_public_path__ + "static/media/bg-papermoon.8c8744a4.jpg";